export default __webpack_public_path__ + "static/media/asana.4f80f003.svg";